<template>
  <div class="pagination-section">

    <div class="pagination-arrows previous-arrows" v-if="showArrows">
      <div class="pagination-first-page">
        <div :class="['arrow double-arrow left', { disabled: currentPage === 1 }]"
            @click="changePage(1)"></div>
      </div>
      <div :class="['arrow left', { disabled: currentPage === 1 }]"
          :data-page="previousPage"
          @click="changePage(previousPage)"></div>
    </div>

    <div class="pagination-pages">
      <span v-for="(page, index) in pagesToList"
            :key="index"
            :id="page"
            :class="['page', { selected: currentPage === page }]"
            @click="changePage(page)"
            :data-page="page">
        {{ page }}
      </span>
    </div>

    <div class="pagination-arrows next-arrows" v-if="showArrows">
      <div :class="['arrow right',{ disabled: currentPage === totalPageCount }]"
          :data-page="nextPage"
          @click="changePage(nextPage)"></div>
      <div class="pagination-last-page">
        <div :class="['arrow double-arrow right', { disabled: currentPage === totalPageCount }]"
            @click="changePage(totalPageCount)"></div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    props: {
      showArrows: Boolean,
      currentPage: Number,
      totalPageCount: Number,
    },

    name: 'Pagination',

    methods: {
      changePage(page) {
        if (this.currentPage !== page) {
          this.$emit('changePage', page)
        }
      },
    },

    computed: {
      nextPage: function () {
        const next = parseInt(this.currentPage) + 1
        if (next > this.totalPageCount) {
          return this.totalPageCount
        } else {
          return next
        }
      },

      previousPage: function () {
        const previous = parseInt(this.currentPage) - 1
        if (previous < 1) {
          return 1
        } else {
          return previous
        }
      }, 

      pagesToList: function () {
        let pages
        if (this.totalPageCount <= 5) {
          pages = this.totalPageCount
        } else if (this.currentPage === 1 || this.currentPage === 2) {
          pages = 5          
        } else if ((this.currentPage === this.totalPageCount || this.currentPage === (this.totalPageCount - 1))) {
          pages = [this.totalPageCount - 4, this.totalPageCount - 3, this.totalPageCount - 2, this.totalPageCount - 1, this.totalPageCount]
        } else {
          pages = [this.currentPage - 2, this.currentPage - 1, this.currentPage, this.currentPage + 1, this.currentPage + 2]
        }
        return pages
      }
    },

  }
</script>

<style lang="sass" scoped>
@import '../../assets/sass/colors'

.pagination-section
  align-items: center
  display: flex
  justify-content: center
  margin-top: 1rem
  position: relative

  .pagination-arrows
    display: flex

  .arrow
    border-bottom: 1px solid $primary-color
    border-right: 1px solid $primary-color
    border-radius: 1px
    content: ' '
    cursor: pointer
    height: .5rem
    width: .5rem

    &:hover
      border-bottom: 1px solid $tertiary-color
      border-right: 1px solid $tertiary-color

    &.left
      transform: rotate(135deg)

    &.right
      transform: rotate(-45deg)

    &.disabled
      border-color: lightgray
      color: lightgray
      pointer-events: none

      &:before
        border-color: lightgray !important

  .double-arrow
    margin: 0 5px
    &:hover
      border-bottom: 1px solid $tertiary-color
      border-right: 1px solid $tertiary-color
      &:before
        border-bottom: 1px solid $tertiary-color
        border-right: 1px solid $tertiary-color

    &:before
      border-bottom: 1px solid $primary-color
      border-right: 1px solid $primary-color
      border-radius: 1px
      content: ' '
      display: inline-block
      height: .5rem
      margin: .18rem 0 .2rem .18rem
      width: .5rem

  .pagination-pages
    .page
      color: $primary-color
      cursor: pointer
      font-size: .9rem
      margin: 0 .25rem

      &.selected
        color: $title-color
        pointer-events: none
        &:hover
          color: $title-color

      &:hover
        color: $tertiary-color
</style>